<template>
	<div>
		<div v-if="transactionType === 'Deposit'" class="wallet-gateway text-center">
			<p>{{ $t('session.wallet.processing-screen.cashia-more-text') }}</p>
			<div class="cashia-btn-wrapper">
				<b-button-ii :disabled="false" :loading="false" :title="$t('session.wallet.btn.cashia')" type="primary"
					rounded-small :fit-text="true" full-width @click="payWithCashia">
					<span class="cashia-badge">Free Deposits</span>
					<IconRegistry name="CashiaAppLogo" color="white" />
				</b-button-ii>
			</div>
		</div>

		<div v-else-if="transactionType === 'Withdrawal'" class="wallet-gateway text-center">
			<div class="cashia-btn-wrapper">
				<b-button-ii :disabled="false" :loading="false" :title="$t('session.wallet.btn.cashia-withdrawal')" type="error"
					rounded-small :fit-text="true" full-width @click="withdraw">
					<span class="cashia-badge">Special Offer</span>
					<IconRegistry name="CashiaAppLogo" color="white" />
				</b-button-ii>
			</div>
		</div>

		<!-- Cashia Bottom Sheet -->
		<bottom-sheet v-if="showSheet" ref="bottomSheet" defaultState="close" @has-mounted="onSheetMounted"
			:prevent-bg-close="processing" size="small" @close="onSheetClose">
			<div :style="checkLayoutSetStyle">
				<div class="wallet-gateway__cashia-processes">
					<div class="wallet-gateway__cashia-processes__header-white">
						<IconRegistry name="CashiaAppLogo" color="" />
						<!-- {{ $t('session.wallet.title') }} -->
					</div>
					<div class="wallet-gateway__cashia-processes__content">

						<!-- Main Processing Screen -->
						<section v-show="processing">
							<div class="wallet-gateway__cashia-processes__content--processing__spinner">
								<loader :margin="true" :dark="true" />
							</div>
							<p>
								<processing-dots :text="$t('session.wallet.processing-screen.process-request')" :dots="3"
									:interval="0.6" />
							</p>
						</section>

						<!-- Instructions for (new user) -->
						<section v-show="showInstructionsWithdrawal">
							<div class="wallet-gateway__cashia-processes__content--instructions" style="padding-bottom:10px">
								<p>{{ $t('session.wallet.processing-screen.not-on-cashia.title') }}</p>
								<span>{{ $t('session.wallet.processing-screen.not-on-cashia.desc') }}</span>
							</div>
						</section>

						<section v-show="showInstructions">
							<div class="wallet-gateway__cashia-processes__content--instructions" style="padding-bottom:10px">
								<p>{{ $t('session.wallet.processing-screen.not-on-cashia.title') }}</p>
								<span>{{ $t('session.wallet.processing-screen.not-on-cashia.desc') }}</span>
							</div>
							<div class="promo-banner account__section global-card__type--block"
								:class="{ 'promo-banner--light': theme === 'light' }">
								<div class="icon-container">
									<IconRegistry name="GiftIcon" />
								</div>
								<div class="text-content">
									<h2 class="headline">Cashia gives you more to play with!</h2>
									<span class="subtext">Pay less. Bet More. It's that simple!</span>
								</div>
							</div>
							<a :href="`${env.cashia.cashiaBaseUrl}/?phone=${user.mobile}&source=betika`" target="_blank"
								class="wallet-gateway__cashia-processes__signup">
								<IconRegistry name="CashiaAppLogo" color="white" />
								{{ $t('session.wallet.processing-screen.not-on-cashia.sign-up-btn') }}
							</a>
						</section>

						<!-- Enter PIN  -->
						<section v-show="showEnterPin">
							<div class="wallet-gateway__cashia-processes__content--enter-pin">
								<div>
									<h4>{{ $t('session.wallet.processing-screen.enter-pin') }}</h4>
									<p class="info-pin">{{ $t('session.wallet.processing-screen.enter-pin-desc') }}</p>
									<div v-if="checkLayout == 'Mobile'">
										<p @click="close">Close</p>
									</div>
								</div>
							</div>
						</section>

					</div>
				</div>
			</div>
		</bottom-sheet>
	</div>
</template>

<script>
import IconRegistry from '../../Shared/Icons/IconRegistry.vue';
import BottomSheet from "../../v2/Shared/BottomSheet.vue";
import QrcodeVue from 'qrcode.vue';
import { parseRedesignDepositAmount } from '../../../utils/depositAmount';
export default {
	props: {
		amount: Number,
		transactionType: String
	},
	components: {
		IconRegistry,
		BottomSheet,
		QrcodeVue
	},
	data() {
		return {
			showSheet: false,
			sheetMounted: false,
			userAgent: localStorage.user_agent || '',
			processing: false,
			showInstructions: false,
			showInstructionsWithdrawal: false,
			showEnterPin: false,
		};
	},
	computed: {
		isAndroid() {
			return /Android/i.test(this.userAgent);
		},
		isIOS() {
			return /iPhone|iPad|iPod/i.test(this.userAgent);
		},
		checkLayout() {
			return this.$store.getters.layout;
		},
		checkLayoutSetStyle() {
			return this.checkLayout === 'Mobile'
				? 'margin: 15px;'
				: 'margin: 0px;';
		},
		user() {
			return this.$store.getters.user;
		},
		phone() {
			return this.user.mobile;
		},
		cashiaRedirect() {
			return `${this.env.cashia.cashiaBaseUrl}/login?phone=${this.phone}&source=betika`
		},
		cashiaNoUserRedirect() {
			return `${this.env.cashia.cashiaBaseUrl}/onboarding?phone=${this.phone}&source=betika`
		},
		theme() {
			let vm = this;
			return vm.$store.getters["settings/settings"].themeV2.dark
				? "light"
				: "dark";
		},
	},
	methods: {
		close() {
			this.$refs.bottomSheet.setState("close");
		},
		async forceReopenSheet() {
			if (this.sheetMounted && this.$refs.bottomSheet) {
				// Close first
				this.$refs.bottomSheet.setState("close");

				// Wait for close transition + DOM update
				await new Promise(r => setTimeout(r, 50));
				await this.$nextTick();
				await new Promise(requestAnimationFrame);

				// Reopen after height recalculated
				this.$refs.bottomSheet.setState("open");
			}
		},
		async withdraw() {
			let vm = this;
			vm.error = false;
			if (vm.loading || vm.transacting) return;
			if (vm.amount > 0) {
				vm.loading = true;

				if (Number(vm.amount) < Number(vm.env.minimumWithdrawAmount)) {
					vm.loading = false;
					return vm.$notifications.add({
						message:
							this.$t("account.minimum-withdraw-amount-is") +
							" " +
							vm.$options.filters.currency(vm.env.minimumWithdrawAmount),
						title: this.$t("account.withdraw-amount"),
						type: "warning",
						duration: 5000,
					});
				}

				if (Number(vm.amount) > Number(vm.env.maximumWithdrawAmount)) {
					vm.loading = false;
					return vm.$notifications.add({
						message:
							this.$t("account.maximum-withdraw-amount-is") +
							" " +
							vm.$options.filters.currency(vm.env.maximumWithdrawAmount),
						title: this.$t("account.withdraw-amount"),
						type: "warning",
						duration: 5000,
					});
				}

				const token = vm.$auth.getToken();
				const payload = {
					amount: parseFloat(vm.amount),
					token,
					isCashia: true,
					app_name: "MOBILE_WEB",
				};

				this.analyticsTrack("withdraw", "attempt", {
					mobile: vm.user.mobile,
					user_id: vm.user.id,
					wallet_balance: vm.user.balance,
					withdrawAmount: vm.amount,
					withdrawMethod: "ONLINE",
				});

				vm.$emit("is-transacting", true);
				let url =
					vm.env.depositWithdrawVersion == "v1"
						? `${BASE_URL}withdraw`
						: `${BASE_V2_URL}withdraw`;

				vm.$axios
					.post(url, payload)
					.then((response) => {
						vm.loading = false;
						vm.$emit("is-transacting", false);
						const message =
							vm.env.depositWithdrawVersion == "v1" //TODO confirm with Ronoh if the two versions response is the same.
								? response.data.success.message
								: response.data.success.message;

						vm.$notifications.add({
							message: message,
							type: "success",
							title: this.$t("account.withdraw-initiated"),
							duration: 5000,
						});

						this.analyticsTrack("withdraw", "success", {
							mobile: vm.user.mobile,
							user_id: vm.user.id,
							wallet_balance: vm.user.balance,
							withdrawAmount: vm.amount,
							withdrawMethod: "ONLINE",
							message: message,
						});

						vm.showSheet = false;
						vm.showInstructionsWithdrawal = false;
						vm.loading = false;
						vm.$emit("is-transacting", false);
						vm.amount = null;

						vm.$emit("close");
						if (response.data.url) window.open(response.data.url);
					})
					.catch((error) => {
						vm.loading = false;
						vm.canShowBottomSheet = false;
						vm.$emit("is-transacting", false);
						this.analyticsTrack("withdraw", "failed", {
							mobile: vm.user.mobile,
							user_id: vm.user.id,
							wallet_balance: vm.user.balance,
							withdrawAmount: vm.$options.filters.currency(vm.amount),
							withdrawMethod: "ONLINE",
							message: error.response
								? error.response.data.message
								: error.message,
						});

						if (error.response) {
							if (error.response.status == 401) {
								vm.$auth.logout();
								vm.$router.replace("/login");
								return;
							}


							if (error.response.status == 404) {
								//user doesn't have cashia deposit

								// vm.$notifications.add({
								// 	message: error.response.data.error.message,
								// 	type: "error",
								// 	title: this.$t("account.withdrawal-failed"),
								// 	duration: 10000,
								// });

								vm.showSheet = true;
								vm.processing = false;
								vm.showInstructionsWithdrawal = true;
								vm.showEnterPin = false;
								this.$refs.bottomSheet.recalculateHeight();

								return;
							}

							if (error.response.data.error.message) {
								vm.$notifications.add({
									message: error.response.data.error.message,
									type: "error",
									title: this.$t("account.withdrawal-failed"),
									duration: 5000,
								});
								return;
							}

							if (error.response.status == 421) {
								if (error.response.data.message) {
									vm.$notifications.add({
										message: error.response.data.message,
										type: "error",
										title: this.$t("account.withdrawal-failed"),
										duration: 5000,
									});
									return;
								} else {
									vm.$notifications.add({
										message: error.response.data,
										type: "error",
										title: this.$t("account.withdrawal-failed"),
										duration: 5000,
									});
									return;
								}
							}
							vm.$notifications.add({
								message: error.response.data.message,
								type: "error",
								title: this.$t("account.withdrawal-failed"),
								duration: 5000,
							});
						} else {
							vm.$notifications.add({
								message: this.$t("session.an-error-occured-please-try-again"),
								type: "error",
								title: this.$t("account.withdrawal-failed"),
								duration: 5000,
							});
						}
					});
			} else {
				vm.error = this.$t("account.please-enter-an-amount");
			}
		},

		parseCashiaAmount() {
			return parseRedesignDepositAmount(this.amount, this.env);
		},

		async payWithCashia() {
			let vm = this;

			const parsedAmount = vm.parseCashiaAmount();

			if (parsedAmount === null) {
				vm.$emit('validation-error', vm.$t("account.please-enter-an-amount"));
				return;
			}

			if (parsedAmount < vm.env.minimumDepositAmount) {
				vm.$emit('validation-error', this.$t("account.minimum-deposit-amount-is") +
					" " +
					vm.$options.filters.currency(vm.env.minimumDepositAmount));

				return vm.$notifications.add({
					message:
						this.$t("account.minimum-deposit-amount-is") +
						" " +
						vm.$options.filters.currency(vm.env.minimumDepositAmount),
					title: this.$t("account.deposit-amount"),
					type: "warning",
					duration: 5000,
				});
			}

			if (parsedAmount > vm.env.maximumDepositAmount) {
				vm.$emit('validation-error', this.$t("account.maximum-deposit-amount-is") +
					" " +
					vm.$options.filters.currency(vm.env.maximumDepositAmount));

				return vm.$notifications.add({
					message:
						this.$t("account.maximum-deposit-amount-is") +
						" " +
						vm.$options.filters.currency(vm.env.maximumDepositAmount),
					title: this.$t("account.deposit-amount"),
					type: "warning",
					duration: 5000,
				});
			}

			// Clear any previous error in parent (Deposit.vue)
			vm.$emit('validation-error', '');

			const appSrc = vm.$utils.getAppSource();
			const token = vm.$auth.getToken();

			const payload = {
				amount: parsedAmount,
				token: token,
				src: appSrc,
				payment_method: "CASHIA",
				scenario_id: "2"
			}


			vm.analyticsTrack("deposit", "attempt", {
				mobile: vm.user.mobile,
				user_id: vm.user.id,
				wallet_balance: vm.user.balance,
				depositAmount: vm.$options.filters.currency(parsedAmount),
				depositMethod: "CASHIA",
			});

			vm.showSheet = true;
			vm.processing = true;
			vm.showInstructions = false;
			vm.showEnterPin = false;
			vm.$emit("is-transacting", true);

			const url = vm.env.depositWithdrawVersion == "v1"
				? `${BASE_URL}deposit`
				: `${BASE_V2_URL}deposit`;

			vm.$axios
				.post(url, payload)
				.then((response) => {
					vm.$emit("is-transacting", false);
					const successMessage = response.data.success.message;

					vm.$notifications.add({
						message: successMessage,
						type: "success",
						title: this.$t("account.deposit-initiated"),
						duration: 10000,
					});

					vm.showSheet = false;
					vm.processing = false;
					vm.showInstructions = false;
					vm.showEnterPin = false;
					vm.depositRedirectUrl = response.data.success.webRedirectUrl;
					window.onbeforeunload = null;
					window.open(vm.depositRedirectUrl, "_self");
					this.$refs.bottomSheet.recalculateHeight();
					this.$refs.bottomSheet.setState("close");

					vm.analyticsTrack("deposit", "success", {
						mobile: vm.user.mobile,
						user_id: vm.user.id,
						wallet_balance: vm.user.balance,
						depositAmount: vm.$options.filters.currency(parsedAmount),
						depositMethod: "CASHIA",
						message: "Success",
						isFirstDeposit: 0,
						value: Number(vm.amount) || 0,
						currency: window.CURRENCY,
					});

					vm.$emit("close");
				})
				.catch((error) => {
					vm.$emit("is-transacting", false);

					if (error.response) {
						this.analyticsTrack("deposit", "failed", {
							mobile: vm.user.mobile,
							user_id: vm.user.id,
							wallet_balance: vm.user.balance,
							depositAmount: vm.$options.filters.currency(parsedAmount),
							depositMethod: "CASHIA",
							message: error.response.data.error.message
						});

						if (error.response.status == 401) {
							vm.$auth.logout();
							vm.$router.replace("/login");
							return;
						}

						if (error.response.status == 404) {
							//user doesn't have cashia

							// vm.$notifications.add({
							// 	message: error.response.data.error.message,
							// 	type: "error",
							// 	title: this.$t("account.deposit-failed"),
							// 	duration: 15000,
							// });

							vm.showSheet = false;
							vm.processing = false;
							vm.showInstructions = false;
							window.onbeforeunload = null;
							vm.depositRedirectUrl = error.response.data.error.webRedirectUrl;
							window.open(vm.depositRedirectUrl, "_self");
							vm.showEnterPin = false;
							this.$refs.bottomSheet.recalculateHeight();

							return;
						}

						//handle other errors
						vm.$notifications.add({
							message: error.response.data.error.message,
							type: "error",
							title: vm.$t("account.deposit-failed"),
							duration: 15000,
						});

						vm.showSheet = false;
						vm.processing = false;
						vm.showInstructions = false;
						vm.showEnterPin = false;

					} else {
						vm.$notifications.add({
							message: vm.$t("session.an-error-occured-please-try-again"),
							type: "error",
							title: vm.$t("account.deposit-failed"),
							duration: 5000,
						});
					}

				});

		},

		onSheetMounted() {
			this.sheetMounted = true;
			this.$nextTick(() => {
				if (this.$refs.bottomSheet) {
					this.$refs.bottomSheet.setState("open");
				}
			});
		},

		onSheetClose() {
			if (this.$refs.bottomSheet) {
				try {
					this.$refs.bottomSheet.setState("close");
				} catch (e) { }
			}
			setTimeout(() => {
				this.showSheet = false;
				this.sheetMounted = false;
				this.processing = false;
				this.showInstructions = false;
			}, 350);
		}
	}
};
</script>

<style lang="scss" scoped>
.promo-banner {
	display: flex;
	padding: 8px;
	border-radius: 8px;
	margin: 0 auto;
	max-width: 320px;
	width: 100%;
	box-shadow: 0 2px 8px rgba(0, 0, 0, 0.1);
}

.promo-banner--light {
	background-color: #fff4ce !important;
	border: none;
}

.icon-container {
	flex-shrink: 0;
	margin-right: 8px;
}

.icon {
	width: 48px;
	height: 48px;
	font-size: 48px;
}

.headline {
	font-size: 14px;
	font-weight: 600;
	margin-bottom: 4px;
}

.subtext {
	color: var(--light-dark-blue);
	font-weight: var(--font-weight-lighter);
	margin-bottom: 10px;
}

.text-content {
	flex: 1;
	padding-bottom: 10px;

}

.wallet-gateway {
	// background-color: lime;


	.cashia-btn-wrapper {
		display: flex;
		flex-direction: column;
		align-items: stretch;
		position: relative;
		height: 100%;
		font-weight: 600 !important;
		flex-shrink: 0;

	}

	.cashia-badge {
		position: absolute;
		top: -6px;
		right: 0;
		z-index: 1;
		background-color: #f8fafc;
		color: #dd1f5d;
		font-size: 0.91em;
		font-weight: 400;
		line-height: 1.2;
		padding: 0 0.73em;
		border-radius: 8px;
		white-space: nowrap;

		@media (max-width: 768px) {
			font-weight: 600;
			font-size: 0.73em;
			line-height: 0.625;
			padding: 0.27em 1.27em;
		}
	}

	&__tagline {
		font-weight: 700;
		font-size: 14px;
		font-style: normal;
		line-height: 20px
	}

	&__main-info {
		color: var(--light-dark-blue);
		font-weight: var(--font-weight-lighter);
		font-size: var(--font-small);
		line-height: 16px;

		/* reach into v-html content */
		::v-deep ul {
			margin: 0;
			padding: 0;
		}

		::v-deep li {
			list-style: none;
			margin: 0;
			padding: 1px 0;
		}
	}

	::v-deep .btn {
		height: 36px !important;
		display: flex;
		align-items: center;
		justify-content: center;
		gap: 6px;
		padding: 9px 10px !important;
		box-sizing: border-box;
		border-radius: 8px;
		box-shadow: 0px 1px 2px 0px rgba(16, 24, 40, 0.05);
		background-color: var(--bg-rose-600) !important;
		border-color: var(--bg-rose-600) !important;
		font-size: 11px !important;
		font-weight: 600;
		line-height: 16px !important;
		width: 100%;
	}

	::v-deep .btntitle {
		font-size: 11px !important;
		font-weight: 600;
		line-height: 16px;
		color: white;
		white-space: nowrap;
	}

	::v-deep .btn svg, ::v-deep .btn img {
		width: 18px;
		height: 18px;
		flex-shrink: 0;
	}

	&__cashia-processes {
		text-align: center;


		&__header {
			display: flex;
			align-items: center;
			justify-content: center;
			gap: 10px;
			font-weight: var(--font-weight-bold);
			background-color: var(--bg-rose-600) !important;
			border-radius: 8px;
			padding: 9px;
			color: white;
		}

		&__header-white {
			display: flex;
			align-items: center;
			justify-content: center;
			gap: 6px !important;
			font-weight: var(--font-weight-bold);
			border-radius: 8px;
			padding: 9px;
			color: var(--bg-rose-600);
		}

		&__signup {
			display: flex;
			align-items: center;
			justify-content: center;
			gap: 10px;
			font-weight: var(--font-weight-bold);
			background-color: var(--green) !important;
			border-radius: 8px;
			padding: 9px;
			color: white;
			margin-top: 15px;
			text-decoration: none;
		}

		&__content {
			max-height: 70vh;
			overflow-y: auto;
			color: var(--black);

			&--processing {
				&__spinner {
					margin: 15px auto !important;
				}

				p {
					font-size: larger;
					font-weight: var(--font-weight-bold);
				}
			}

			&--instructions {
				p {
					font-size: larger;
					font-weight: var(--font-weight-bold);
				}

				span {
					color: var(--light-dark-blue);
					font-weight: var(--font-weight-lighter);
				}

				.info {
					font-size: var(--font-small);
					font-weight: var(--font-weight-lighter);
					border: 1px solid var(--line-11);
					border-radius: 10px;
					margin-top: 20px;
					text-align: left;

					::v-deep ol {
						counter-reset: li-counter;
						list-style: none;
						padding: 0 1rem;
					}

					::v-deep li {
						counter-increment: li-counter;
						position: relative;
						padding-left: 2.8em;
						margin-bottom: 0.5em;
						line-height: 1.8rem;
					}

					::v-deep li::before {
						content: counter(li-counter);
						position: absolute;
						left: 0;
						top: 0;
						width: 2em;
						height: 2em;
						background-color: var(--line-11);
						color: var(--black);
						text-align: center;
						line-height: 2em;
						border-radius: 50%;
						font-weight: normal;
						font-size: 0.875rem;
					}
				}
			}

			&--enter-pin {
				.info-pin {
					color: var(--light-dark-blue);
					font-weight: var(--font-weight-lighter);
					font-size: var(--font-small);
				}

				.padlock-icon {
					margin: 8px auto;
					font-size: var(--font-large);
					font-weight: var(--font-weight-lighter);
					background-color: var(--green);
					color: var(--white);
					border-radius: 50%;
					line-height: 52px;
					height: 52px;
					width: 52px;
					display: flex;
					flex-direction: column;
					align-items: center;
					justify-content: center;
				}
			}

			.qr-code .qr-block {
				padding: 8px;
				margin-top: 20px;
				background-color: var(--always-white);
			}

			.store-icons {
				display: inline-flex;
				gap: 20px;
				margin-top: 15px;

				a {
					font-size: var(--font-smallest);
					color: var(--light-dark-blue);
					text-decoration: none !important;

					.icons {
						margin-top: 8px;
						display: inline-flex;
						gap: 8px;
						align-items: center;
					}
				}
			}
		}
	}
}
</style>
